import { render, staticRenderFns } from "./taClientInfo.vue?vue&type=template&id=0e5c417e&scoped=true&"
import script from "./taClientInfo.vue?vue&type=script&lang=js&"
export * from "./taClientInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5c417e",
  null
  
)

export default component.exports